export default __webpack_public_path__ + "static/media/887.323e7441.png";